<app-sliding-window [toggleWindow]="showCommentWindow$ | async" [contentPaddingRem]="0">
  <div header>
    <app-sliding-window-header
      [slidingWindowOptions]="commentWindowOptions$ | async"
      (closeButtonClicked)="form.resetForm(); toggleCommentWindow()" />
    <div class="header-content" *ngIf="headerText">
      {{ headerText }}
    </div>
  </div>
  <div content>
    <app-comments-form
      #form
      [headerHeight]="!!headerText ? '4.5rem' : '0rem'"
      [comments]="comments"
      [isLoading]="isLoading"
      [dropdownItems]="dropdownItems"
      (filterText)="filterText.emit($event)"
      (commentValueChanged)="onCommentValueChange($event)"
      (newComment)="newComment.emit($event)" />
  </div>
  <app-sliding-window-footer
    footer
    [hideActionButton]="isCommentEmpty$ | async"
    [displayCompletedStateButtons$]="isCommentEmpty$"
    [slidingWindowOptions]="commentWindowOptions$ | async"
    (primaryButtonClicked)="form.submitForm()"
    (secondaryButtonClicked)="form.resetForm(); toggleCommentWindow()" />
</app-sliding-window>

<app-comment-button [showNotificationDot]="hasUnreadComments$ | async" (buttonClicked)="toggleCommentWindow()" />
